import { type ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn, defaultSizesForIcons } from "@genuin/ui/lib/utils";

// Define the iconVariant function using cva to handle different styles based on props
const iconVariant = cva("", {
  variants: {
    theme: {
      dark: "gencl:fill-white", // Light variant style
      light: "gencl:fill-dark", // Dark variant style
    },
    size: defaultSizesForIcons(),
  },
});

// Define the Props type for the ExpandIcon component
type ExpandIconPropsType = ComponentProps<"svg"> &
  VariantProps<typeof iconVariant>;

export function ExpandIcon({
  theme,
  size,
  className,
  ...restProps
}: ExpandIconPropsType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn(iconVariant({ theme, size }), className)}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.36181 9.63819C3.59347 9.86985 3.90767 10 4.23529 10C4.56291 10 4.87712 9.86985 5.10878 9.63819C5.34044 9.40653 5.47059 9.09233 5.47059 8.76471V5.79012C5.47059 5.70537 5.50425 5.6241 5.56418 5.56418C5.6241 5.50425 5.70537 5.47059 5.79012 5.47059H8.76471C9.09233 5.47059 9.40653 5.34044 9.63819 5.10878C9.86985 4.87712 10 4.56291 10 4.23529C10 3.90767 9.86985 3.59347 9.63819 3.36181C9.40653 3.13015 9.09233 3 8.76471 3H5.79012C5.05093 3.0026 4.34277 3.2974 3.82008 3.82008C3.2974 4.34277 3.0026 5.05093 3 5.79012V8.76471C3 9.09233 3.13015 9.40653 3.36181 9.63819ZM18.8912 9.63819C19.1229 9.86985 19.4371 10 19.7647 10C20.0923 10 20.4065 9.86985 20.6382 9.63819C20.8699 9.40653 21 9.09233 21 8.76471V5.79012C20.9974 5.05093 20.7026 4.34277 20.1799 3.82008C19.6572 3.2974 18.9491 3.0026 18.2099 3H15.2353C14.9077 3 14.5935 3.13015 14.3618 3.36181C14.1301 3.59347 14 3.90767 14 4.23529C14 4.56291 14.1301 4.87712 14.3618 5.10878C14.5935 5.34044 14.9077 5.47059 15.2353 5.47059H18.2099C18.2946 5.47059 18.3759 5.50425 18.4358 5.56418C18.4957 5.6241 18.5294 5.70537 18.5294 5.79012V8.76471C18.5294 9.09233 18.6596 9.40653 18.8912 9.63819ZM18.2099 21H15.2353C14.9077 21 14.5935 20.8699 14.3618 20.6382C14.1301 20.4065 14 20.0923 14 19.7647C14 19.4371 14.1301 19.1229 14.3618 18.8912C14.5935 18.6596 14.9077 18.5294 15.2353 18.5294H18.2099C18.2946 18.5294 18.3759 18.4957 18.4358 18.4358C18.4957 18.3759 18.5294 18.2946 18.5294 18.2099V15.2353C18.5294 14.9077 18.6596 14.5935 18.8912 14.3618C19.1229 14.1301 19.4371 14 19.7647 14C20.0923 14 20.4065 14.1301 20.6382 14.3618C20.8699 14.5935 21 14.9077 21 15.2353V18.2099C20.9974 18.9491 20.7026 19.6572 20.1799 20.1799C19.6572 20.7026 18.9491 20.9974 18.2099 21ZM5.79012 21H8.76471C9.09233 21 9.40653 20.8699 9.63819 20.6382C9.86985 20.4065 10 20.0923 10 19.7647C10 19.4371 9.86985 19.1229 9.63819 18.8912C9.40653 18.6596 9.09233 18.5294 8.76471 18.5294H5.79012C5.70537 18.5294 5.6241 18.4957 5.56418 18.4358C5.50425 18.3759 5.47059 18.2946 5.47059 18.2099V15.2353C5.47059 14.9077 5.34044 14.5935 5.10878 14.3618C4.87712 14.1301 4.56291 14 4.23529 14C3.90767 14 3.59347 14.1301 3.36181 14.3618C3.13015 14.5935 3 14.9077 3 15.2353V18.2099C3.0026 18.9491 3.2974 19.6572 3.82008 20.1799C4.34277 20.7026 5.05093 20.9974 5.79012 21Z"
      />
    </svg>
  );
}
